import { getScrollX, getScrollY } from '../../ADNDHelpers'
import { PRIVATE as ADNDDropTarget_PRIVATE, PUBLIC as ADNDDropTarget_PUBLIC } from '../ADNDDropTarget'

function DEFAULT_PROPS() {
  return {
    type: null,
    list: null,
    node: null,
    rect: null,
    edge: null,
    dragLayerClassName: null,
    hidden: false,
    finalizeDragLayerContentHandler: null,
    isLockedHandler: null
  }
}

const PRIVATE = {
  fetchRect(scrollX = getScrollX(), scrollY = getScrollY()) {
    return ADNDDropTarget_PRIVATE.fetchRect.call(this, scrollX, scrollY)
  },
  isLocked() {
    return this.props.isLockedHandler ? this.props.isLockedHandler() : false
  }
}

const PUBLIC = {
  clone(withProps = {}) {
    return ADNDListItem(Object.assign({}, this.props, withProps))
  },
  connect(node) {
    if (node != this.props.node) {
      if (null != node) {
        if (null != this.props.list) {
          this.props.list.addItem(this)
        }
      } else {
        this.PUBLIC.disconnect()
      }
      this.props.node = node
    }
    return this.PUBLIC
  },
  disconnect() {
    if (null != this.props.node) {
      if (null != this.props.list) {
        if (this.props.hidden) {
          this.PUBLIC.doShow()
        }
        this.props.list.removeItem(this)
      }
      this.props.node = null
      this.props.rect = null
    }
    return this.PUBLIC
  },
  connectedNode() {
    return this.props.node
  },
  setList(list) {
    if (list != this.props.list) {
      if (null != this.props.list) {
        this.props.list.removeItem(this)
      }
      if (null != list) {
        list.addItem(this)
      }
      this.props.list = list
    }
    return this.PUBLIC
  },
  getList() {
    return this.props.list
  },
  getDragLayerClassName() {
    return this.props.dragLayerClassName
  },
  doHide() {
    if (!this.props.hidden) {
      if (null != this.props.list) {
        this.props.list.hideItem(this)
      }
      this.props.hidden = true
    }
    return this.PUBLIC
  },
  doShow() {
    if (this.props.hidden) {
      if (null != this.props.list) {
        this.props.list.showItem(this)
      }
      this.props.hidden = false
    }
    return this.PUBLIC
  },
  isHidden() {
    return this.props.hidden
  },
  onFinalizeDragLayerContent(finalizeDragLayerContentHandler) {
    if ('function' == typeof finalizeDragLayerContentHandler) {
      this.props.finalizeDragLayerContentHandler = finalizeDragLayerContentHandler
    }
    return this.PUBLIC
  },
  doFinalizeDragLayerContent(node) {
    return this.props.finalizeDragLayerContentHandler ? this.props.finalizeDragLayerContentHandler(node) : node
  },
  isLocked(isLockedHandler) {
    if ('function' == typeof isLockedHandler) {
      this.props.isLockedHandler = isLockedHandler
    }
    return this.PUBLIC
  },
  setEdges(top = 0, right = 0, bottom = 0, left = 0) {
    return ADNDDropTarget_PUBLIC.call(this, top, right, bottom, left)
  }
}

export default function ADNDListItem(props = {}) {
  const ADNDListItem = {
    props: Object.assign({}, DEFAULT_PROPS(), props)
  }

  ADNDListItem.PRIVATE = {
    fetchRect: PRIVATE.fetchRect.bind(ADNDListItem),
    isLocked: PRIVATE.isLocked.bind(ADNDListItem)
  }

  ADNDListItem.PUBLIC = {
    clone: PUBLIC.clone.bind(ADNDListItem),
    connect: PUBLIC.connect.bind(ADNDListItem),
    disconnect: PUBLIC.disconnect.bind(ADNDListItem),
    connectedNode: PUBLIC.connectedNode.bind(ADNDListItem),
    setList: PUBLIC.setList.bind(ADNDListItem),
    getList: PUBLIC.getList.bind(ADNDListItem),
    getDragLayerClassName: PUBLIC.getDragLayerClassName.bind(ADNDListItem),
    doHide: PUBLIC.doHide.bind(ADNDListItem),
    doShow: PUBLIC.doShow.bind(ADNDListItem),
    isHidden: PUBLIC.isHidden.bind(ADNDListItem),
    onFinalizeDragLayerContent: PUBLIC.onFinalizeDragLayerContent.bind(ADNDListItem),
    doFinalizeDragLayerContent: PUBLIC.doFinalizeDragLayerContent.bind(ADNDListItem),
    isLocked: PUBLIC.isLocked.bind(ADNDListItem),
    setEdges: PUBLIC.setEdges.bind(ADNDListItem)
  }

  return ADNDListItem.PUBLIC
}
